import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { sanitizeSvg } from "@/shared/lib/sanitizeSvg";
import { cn } from "@/shared/lib/utils";
import styles from "./PresetImage.module.scss";
/**
 * Рендер картинки пресета (паттерн/иконка).
 *
 * Приоритет: `image_svg` → инлайн-вставка (санитизированная), чтобы работал
 * `currentColor` и SVG наследовал `color` окружения; иначе `image_url` → <img>.
 * Инлайн-SVG обязательно прогоняется через DOMPurify (см. sanitizeSvg).
 */
export const PresetImage = ({ preset, className, decorative = false, }) => {
    const safeSvg = React.useMemo(() => (preset.image_svg ? sanitizeSvg(preset.image_svg) : ""), [preset.image_svg]);
    if (safeSvg) {
        return (_jsx("span", { className: cn(styles.svg, className), role: decorative ? "presentation" : "img", "aria-label": decorative ? undefined : preset.name, 
            // Санитизировано выше (DOMPurify, SVG-профиль).
            dangerouslySetInnerHTML: { __html: safeSvg } }));
    }
    if (preset.image_url) {
        return (_jsx("img", { className: cn(styles.img, className), src: preset.image_url, alt: decorative ? "" : preset.name, loading: "lazy" }));
    }
    return null;
};
